import { useCustomTranslation } from "@/hooks/useTranslation";
import React from "react";

function Loader(props) {
  const { tpLoaded, is3DControlsLoaded, text, complementaryColor } = props;
  const { content } = useCustomTranslation();

  const getContent = (group, key) => {
    return content(`other.${group}.${key}`);
  };
  return (
    <div
      className="bounty_spinner_container"
      style={
        !tpLoaded || is3DControlsLoaded
          ? {
              display: "block",
              zIndex: 99,
              backgroundColor: is3DControlsLoaded ? "#000000a6" : "#00000017",
            }
          : { display: "none", zIndex: -1 }
      }
    >
      <div
        className={"bounty_spinner"}
        style={
          !tpLoaded || is3DControlsLoaded
            ? { display: "block", zIndex: 99 }
            : { display: "none", zIndex: -1 }
        }
      >
        <div className={"bounty_double_bounce1"}></div>
        <div className={"bounty_double_bounce2"}></div>
      </div>
      <div
        className={"bounty_loading_title"}
        style={
          !tpLoaded || is3DControlsLoaded
            ? {
                display: "block",
                zIndex: 99,
                color: is3DControlsLoaded ? "#FFFFFF" : complementaryColor,
              }
            : { display: "none", zIndex: -1 }
        }
      >
        {getContent("labels", text)}
      </div>
    </div>
  );
}

export default Loader;
